import { FC } from 'react';
import { navigate } from 'gatsby';
import classNames from 'classnames';
import { DefaultLayout, PaymentMethodList } from '../../../components';

const AccountPaymentMethodsPage: FC = () => (
  <DefaultLayout backTo={() => navigate(-1)} title="Payment Methods" className={classNames('account-payment-methods')}>
    <PaymentMethodList />
  </DefaultLayout>
);

export default AccountPaymentMethodsPage;
